import { ConsentFramework } from './models/consent';

const TCF_COUNTRIES = new Set([
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
  'UK',
  'CH',
]);

/** Detect governing framework. US is treated like Quebec. (the gamigo way) */
export function detectFramework(country?: string, state?: string): ConsentFramework {
  const c = (country ?? '').toUpperCase();
  const s = (state ?? '').toUpperCase();
  if (!c) return 'Unknown';
  if (c === 'US') return 'Quebec';
  if (c === 'CA' && s === 'QC') return 'Quebec';
  if (c === 'BR') return 'LGPD';
  if (TCF_COUNTRIES.has(c)) return 'TCF'; //TCF = Transparency and Consent Framework (from IAB Europe).
  return 'Global';
}

export function hasAllGroups(active: string[], required: string[]): boolean {
  const set = new Set(active);
  return required.every((id) => set.has(id));
}
